var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0729 3.24294C16.8073 2.97738 16.449 2.8284 16.0733 2.8284H12.5367V2.12238C12.5367 0.949992 11.5867 0 10.4143 0H7.58588C6.41351 0 5.4635 0.949992 5.4635 2.12238V2.8284H1.92691C1.55123 2.8284 1.19284 2.97738 0.92725 3.24294C0.661686 3.50852 0.512695 3.86909 0.512695 4.24477C0.512695 4.6334 0.830075 4.95079 1.22088 4.95079H16.7793C17.1701 4.95079 17.4875 4.6334 17.4875 4.24477C17.4875 3.86909 17.3385 3.50852 17.0729 3.24294ZM11.1225 2.8284H6.87769V2.12238C6.87769 1.73158 7.1951 1.4142 7.58588 1.4142H10.4143C10.8051 1.4142 11.1225 1.73158 11.1225 2.12238V2.8284Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.365 6.36523V16.8778C15.365 17.4414 15.1426 17.9811 14.7432 18.3784C14.3459 18.7757 13.8061 19.0002 13.2448 19.0002H4.75525C4.19387 19.0002 3.65409 18.7757 3.25683 18.3784C2.8574 17.9811 2.63501 17.4414 2.63501 16.8778V6.36523H15.365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3177b0c043ccc1ee7dc8366fe1a8c9dd.svg";
export { ForwardRef as ReactComponent };